export default [
  {
    id: '1',
    title: 'Leading SME-focused lending, factoring and leasing company',
    finsought: '$20 - $100 million',
    country: 'Cote d’Ivoire',
    sector: 'Financial Services',
    isEquityInvestment: true,
    isDebtInvestment: true,
    brief: 'Leading SME-focused lending, factoring and leasing company with over 20-years of operations.'
  },
  {
    id: '2',
    title: 'Innovative digital-first financial institution',
    finsought: '$5 - $20 million',
    country: 'Ghana',
    sector: 'Financial Services',
    isEquityInvestment: true,
    isDebtInvestment: false,
    brief: 'Innovative digital-first, licensed financial instutution serving underbanked commerical and retail clients with efficiently designed branches and kiosks.'
  },
  {
    id: '7',
    title: '$100m Investment vehicle focusing on impactful investments in East Africa',
    targetRegion: 'East African',
    finsoughtText: '$1 million',
    sector: 'Healthcare, Energy, Agriculture, Financial, Water & Sanitation',
    isLpEquity: true,
    brief: 'Experienced investment team raising a second fund to focus on follow-on investments into current portfolio companies and new opportunities in East Africa. Investments will target the rising consumer class that are demanding more and better access to goods and services in underdeveloped markets. The fund will focus on series A and series B investments into enterprises that promote gender inclusivity and support minority or underserved groups, as well as opportunities that help to address global and regional challenges like access to clean water and energy.'
  },
  {
    id: '3',
    title: 'Operator of a chain of medical centers in urban Kenya seeking capital to expand locations and services',
    finsought: '$5 - $20 million',
    country: 'Kenya',
    sector: 'Healthcare and Health Technologies',
    isEquityInvestment: true,
    isDebtInvestment: false,
    brief: 'Operator of a chain of medical centers in urban Kenya offering high-quality, affordable healthcare services to underserved communities.  Seeking capital to expand locations and services.'
  },
  {
    id: '4',
    title: 'One of the largest Nursing & Midwifery colleges in the SADC region seeks expansion capital',
    finsought: '$20 - $100 million',
    country: 'Malawi',
    sector: 'Education and Training Services',
    isEquityInvestment: true,
    isDebtInvestment: true,
    brief: 'One of the largest Nursing & Midwifery colleges in the SADC region seeks expansion capital to address a critical shortage of modern, safe, and convenient student housing for undergradiate and graduate students.'
  },
  {
    id: '5',
    title: 'Developer of residential homes seeking capital to expand',
    finsought: '$20 - $100 million',
    country: 'West Africa',
    sector: 'Design and Construction',
    isEquityInvestment: true,
    isDebtInvestment: false,
    brief: 'Developer of residential homes for African diaspora in their home countries.  Seeking capital to expand successful business across West Africa.'
  },
  {
    id: '6',
    title: 'Developer and operator of passive infrastructure and tower sites seeking capital to expand.',
    finsought: '$5 - $20 million',
    country: 'Uganda',
    sector: 'ICT and Digital Economy',
    isEquityInvestment: true,
    isDebtInvestment: true,
    brief: 'Developer and operator of passive infrastructure and tower sites across the whole of Uganda with the ambition to expand into other East African Markets.'
  }
]
